// Header.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  // Pages sur lesquelles seul le logo et le tagline doivent être affichés
  const logoOnlyPages = ['/', '/login', '/register', '/admin/login', '/admin/dashboard', '/forgot-password'];
  const isLogoOnlyPage = logoOnlyPages.includes(location.pathname);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Close mobile menu when navigating
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  // Prevent body scrolling when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  
  return (
    <header className="header">
      <div className="logo">
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo ProspXion" />
        {isLogoOnlyPage && <span className="tagline">ProspXion - Propulsez votre prospection vers de nouveaux sommets !</span>}
        {!isLogoOnlyPage && <span className="tagline">ProspXion</span>}
      </div>
      
      {!isLogoOnlyPage && (
        <>
          {/* Hamburger menu icon for mobile */}
          <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          
          {/* Desktop navigation */}
          <nav className="desktop-nav">
            <ul>
              <li>
                <Link to="/dashboard">Tableau de bord</Link>
              </li>
              <li>
                <Link to="/assistant-ia">ProspX - Assistant IA</Link>
              </li>
              <li>
                <Link to="/fresh">F.R.E.S.H</Link>
              </li>
              <li>
                <Link to="/global">G.L.O.B.A.L</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </nav>
          
          {/* Desktop header buttons */}
          <div className="header-right desktop-header-right">
            <button onClick={() => navigate('/settings')}>Paramètres</button>
            <button onClick={() => navigate('/instructions')}>Mode d'emploi</button>
            <button onClick={handleLogout}>Déconnexion</button>
          </div>
          
          {/* Mobile sidebar navigation */}
          <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
            <div className="mobile-sidebar-header">
              <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo ProspXion" className="mobile-logo" />
              <button className="close-sidebar" onClick={toggleMobileMenu}>×</button>
            </div>
            <nav className="mobile-nav">
              <ul>
                <li>
                  <Link to="/dashboard">Tableau de bord</Link>
                </li>
                <li>
                  <Link to="/assistant-ia">ProspX - Assistant IA</Link>
                </li>
                <li>
                  <Link to="/fresh">F.R.E.S.H</Link>
                </li>
                <li>
                  <Link to="/global">G.L.O.B.A.L</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/settings">Paramètres</Link>
                </li>
                <li>
                  <Link to="/instructions">Mode d'emploi</Link>
                </li>
                <li>
                  <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>Déconnexion</a>
                </li>
              </ul>
            </nav>
          </div>
          
          {/* Overlay for mobile sidebar */}
          <div 
            className={`mobile-sidebar-overlay ${isMobileMenuOpen ? 'active' : ''}`} 
            onClick={toggleMobileMenu}
            style={{ display: isMobileMenuOpen ? 'block' : 'none' }}
          ></div>
        </>
      )}
    </header>
  );
}

export default Header;